import { SVGProps } from 'react';

export const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		cursor="pointer"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx="12" cy="4.94434" r="1.5" fill="#130F31" />
		<circle cx="12" cy="12" r="1.5" fill="#130F31" />
		<circle cx="12" cy="19.0557" r="1.5" fill="#130F31" />
	</svg>
);
